module.exports = __webpack_public_path__ + "img/au.0af6624d.svg";